module.exports = __webpack_public_path__ + "static/media/LoginPage@1x.5db71fd2.png";